import React, { Component, createRef } from "react";
import {
  GET,
  POST,
  loading,
  tokens,
  locale,
  alert,
  Status,
  params,
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_product: [],
      type: params("filter") || "ทั้งหมด",
    };
  }
  componentDidMount = async () => {
    loading(false);
      this.Get();
  };
  Get = async () => {
    loading(true);let result = null;
    let response = await fetch(process.env.REACT_APP_API_URL + "/updated.json");
    let update = await response.json();
    if (
      !tokens ||
      (tokens && tokens?.updated?.last_update !== update.last_update)
    ) {
    let response = await fetch(process.env.REACT_APP_API_URL + "/.json");
    result = await response.json();
    localStorage.setItem("scp-acc-tk", JSON.stringify(result));}else{
      result = tokens;
    }
    this.setState({
      data_product: result?.product ? Object.values(result?.product) : [],
    });
    loading(false);
  };
  render() {
    const { data_product, type } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light position-relative">
        <Navbar />

        {/* SECTION 1 */}
        <div
          className="w-100 text-white position-relative"
          style={{
            minHeight: 350,
            backgroundImage: `url(${require("../assets/images/bg-4.jpg")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="text-center p-5 position-relative"
            style={{
              minHeight: 350,
            }}
          >
            <div className="w-100 d-flex justify-content-center mt-4">
              <div
                className="px-3 py-5 mt-4 rounded"
                style={{
                  backgroundColor: "rgba(0,0,0,0.3)",
                  maxWidth: 400,
                  minWidth: 300,
                  width: "70%",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)", // Safari
                }}
              >
                <h1 className="fw-bold mb-2">สินค้า</h1>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 1 */}
        <div className="d-flex flex-wrap justify-content-center pt-4">
          <button
            className={`btn ${
              type === "ทั้งหมด" ? "btn-primary" : "btn-outline-primary"
            } px-4 mx-1 mb-2`}
            onClick={() => {
              this.setState({ type: "ทั้งหมด" });
            }}
          >
            ทั้งหมด
          </button>
          <button
            className={`btn ${
              type === "ใช้พลังงานไฟฟ้าและเชื้อเพลิง" ? "btn-primary" : "btn-outline-primary"
            } px-4 mx-1 mb-2`}
            onClick={() => {
              this.setState({ type: "ใช้พลังงานไฟฟ้าและเชื้อเพลิง" });
            }}
          >
            ใช้พลังงานไฟฟ้าและเชื้อเพลิง
          </button>
          <button
            className={`btn ${
              type === "ไม่ใช้พลังงานไฟฟ้าและเชื้อเพลิง" ? "btn-primary" : "btn-outline-primary"
            } px-4 mx-1 mb-2`}
            onClick={() => {
              this.setState({ type: "ไม่ใช้พลังงานไฟฟ้าและเชื้อเพลิง" });
            }}
          >
            ไม่ใช้พลังงานไฟฟ้าและเชื้อเพลิง
          </button>
        </div>
        {/* SECTION 2 */}
        <div className="w-100 align-content-center pt-4 pb-5">
          <div className="row container mx-auto justify-content-center px-4">
            {data_product.filter((e) => !type || e.th_type === type || type === "ทั้งหมด").map((item, index) => (
              <div
                className={"col-12 col-sm-6 col-lg-4 col-xl-3 mb-3 p-1 product pointer"}
                onClick={() => {
                  window.location.href = "/detail-product?id=" + item.uid;
                }}
              >
                <div className="w-100 hpx-400 bg-light d-flex align-items-center justify-content-center position-relative rounded-3 overflow-hidden mb-3 shadow-sm">
                  <img
                      alt="LOGO"
                      src={item.photo[0] || LOGO}
                      className="h-100 w-100 mx-auto my-5"
                      style={{ objectFit: "cover" }}
                      loading="lazy"
                    />
                </div>

                <h6
                  className="fw-bold w-100 overflow-hidden mb-2 text-nowrap"
                  style={{ textOverflow: "ellipsis" }}
                >
                  {item[`${locale}_product_name`] || item.th_product_name || ""}
                </h6>
                <small
                  className="text-secondary"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {item[`${locale}_description`] || item.th_description || ""}
                </small>
                <button className="btn btn-primary px-4 mt-3">รายละเอียด</button>
              </div>
            ))}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
